/** @file This file deals with handling Jupyter mime types. */
import * as codec from 'purify-ts/Codec';
import { multilineString } from './parsers';
/**
 * The order of preference to render mime types in the output in.
 */
export const RENDER_ORDER = Object.freeze([
    'image/png',
    'text/html',
    'text/markdown',
    'text/latex',
    'image/gif',
    'image/jpeg',
    'image/svg+xml',
    'text/plain',
    'application/pdf',
]);
/** A listing of just the image mime types. */
export const IMAGE_TYPES = Object.freeze(RENDER_ORDER.filter(mimeType => mimeType.startsWith('image/')));
/**
 * Mapping of mime types to their respective parsers.
 * HTML and plain text use multilineString parser, while others use string parser.
 */
export const parsers = Object.freeze({
    'text/html': multilineString,
    'text/plain': multilineString,
    'text/markdown': multilineString,
    'text/latex': multilineString,
    'image/png': codec.string,
    'image/gif': codec.string,
    'image/jpeg': codec.string,
    'image/svg+xml': codec.string,
    'application/pdf': codec.string,
});
/**
 * Type guard function to check if a given mime type is an image mime type.
 *
 * @param mimeType The mime type to check.
 * @returns True if the mime type is an image mime type.
 */
export function isImage(mimeType) {
    return IMAGE_TYPES.includes(mimeType);
}
